export const ticketPriorityHelper = (priority) => {
  const TicketPriority = {
    RUSH:  "Rush",
    SHRT:  "Short",
    NORM:  "Normal",
    REMK:  "Remark",
    DSGN:  "Design",
    EMER:  "Emergency",
  };
  const formattedPriority = TicketPriority[priority] || priority
  return formattedPriority;
};


export const mergeDigInByIndex = (featureImportanceLookup, metadata) => {
  const { actual_values, feature_importance } = metadata;
  const combinedData = [];
  for (const index in featureImportanceLookup) {
    const combinedEntry = {};
    combinedEntry.shap = feature_importance[index] || 0;
    combinedEntry.actual_value = actual_values[index] || 0;
    combinedEntry.name = featureImportanceLookup[index][0] || '';
    combinedEntry.readableName = featureImportanceLookup[index][1] || '';
    combinedData.push(combinedEntry);
  }
  return combinedData;
};

export const sortDiginByShap = (digInData) => {
  return digInData.sort((a, b) => {
    const absoluteValShapA = Math.abs(a.shap);
    const absoluteValShapB = Math.abs(b.shap);
    return absoluteValShapB - absoluteValShapA;
  });
};

export const getDigInRankMapping = (prediction) => {
  const digInRankMapping = {
    0: { color: 'green', text: 'Low (0 - 80)' },
    80: { color: '#c0c028', text: 'Medium (80 - 90)' },
    90: { color: '#e59604', text: 'High (90 - 95)' },
    95: { color: 'red', text: 'Highest (95 - 100)' },
  };
  return digInRankMapping[
    Object.keys(digInRankMapping).reduce((prevRankKey, currentRankKey) => {
      return prediction >= currentRankKey ? currentRankKey : prevRankKey;
    })
  ];
};
